<template>

  <v-dialog v-model="navigation.CRMWhatsappConversationsDialogIsVisible" max-width="80vw" style="user-select: none; cursor: default;">
    <v-card style="max-height: 95vh; display: flex; flex-direction: column;">
      <div style="position: sticky; top: 0; z-index: 10; background: white;">
        <v-card color="primary" rounded="0" elevation="0" class="headerCard">
          <div class="titleContainer">
            <v-icon color="indigo" size="large">mdi-chat</v-icon>
            <template v-if="navigation.newCRMWhatsappContact">
              <h3>CONVERSACIONES NO VENDIDAS DE NUEVOS CONTACTOS</h3>
            </template>
            <template v-else>
              <h3>CONVERSACIONES NO VENDIDAS</h3>
            </template>
          </div>
          <div class="actionsContainer">
            <v-btn 
              @click="navigation.CRMWhatsappConversationsDialogIsVisible = false"
              :disabled="loader.selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformation || loader.selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformationPagination"
              color="error" 
              class="hoverableText" 
            >
              <v-icon style="margin-right: 10px;">mdi-close-circle</v-icon>
              <p>CERRAR</p>
            </v-btn>
          </div>
        </v-card>
        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
        <v-data-table 
          :headers="computed_CRMWhatsappConversationsHeaders" 
          :items="display.CRMWhatsappConversations"
          :loading="loader.selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformation"
          :items-per-page="-1" 
          density="compact"
          loading-text=""
          hover
          fixed-header
          style="min-height: 65vh; height: 65vh; max-height: 65vh; overflow-y: auto;"
        >
          <template v-slot:header.CRMWhatsappConversationID>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon size="small" color="indigo">mdi-barcode</v-icon>
              <p><strong>ID</strong></p>
            </div>
          </template>
          <template v-slot:header.CRMWhatsappContactID>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon size="small" color="indigo">mdi-account</v-icon>
              <p><strong>CONTACTO</strong></p>
            </div>
          </template>
          <template v-slot:header.CRMWhatsappConversationFirstCRMAgentID>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon size="small" color="indigo">mdi-calendar-start</v-icon>
              <p><strong>INICIO</strong></p>
            </div>
          </template>
          <template v-slot:header.CRMWhatsappConversationCurrentCRMAgentID>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon size="small" color="indigo">mdi-calendar-end</v-icon>
              <p><strong>FIN</strong></p>
            </div>
          </template>
          <template v-slot:header.CRMWhatsappConversationDuration>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon size="small" color="indigo">mdi-clock</v-icon>
              <p><strong>DURACIÓN</strong></p>
            </div>
          </template>
          <template v-slot:header.CRMWhatsappConversationResult>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon size="small" color="indigo">mdi-timeline</v-icon>
              <p><strong>RESULTADO</strong></p>
            </div>
          </template>
          <template v-slot:header.CRMWhatsappConversationAction>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon size="small" color="indigo">mdi-chat</v-icon>
              <p><strong>CONVERSACIÓN</strong></p>
            </div>
          </template>
          <template v-slot:header.CRMWhatsappConversationResumeAction>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon size="small" color="indigo">mdi-chat-plus</v-icon>
              <p><strong>RETOMAR</strong></p>
            </div>
          </template>
          <template v-slot:item="row">
            <tr :class="loader.selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformationPagination ? 'loadingVDataTableRow' : null" :style="loader.selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformationPagination ? 'pointer-events: none;' : null">
              <td>
                <v-hover v-slot="{ isHovering, props: hoverProps }">
                  <template v-if="isHovering == true && !systemInformationData.tooltipDisabled">
                    <v-tooltip v-bind="hoverProps" text="Copiar ID al portapapeles" location="top">
                      <template v-slot:activator="{ props: tooltipProps }">
                        <p v-bind="tooltipProps" @click="$generalFunctions.default.copyToClipboard(this, 'ID de la conversación', 'c', row.item.CRMWhatsappConversationID)" class="hoverableText" style="color: #3F51B5;"><strong>{{ row.item.CRMWhatsappConversationID }}</strong></p>
                      </template>
                    </v-tooltip>
                  </template>
                  <template v-else>
                    <p v-bind="hoverProps" @click="$generalFunctions.default.copyToClipboard(this, 'ID de la conversación', 'c', row.item.CRMWhatsappConversationID)" class="hoverableText" style="color: #3F51B5;"><strong>{{ row.item.CRMWhatsappConversationID }}</strong></p>
                  </template>
                </v-hover>
              </td>
              <td>
                <div style="white-space: nowrap;">
                  <p>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(row.item) }}</p>
                  <p style="font-size: small; color: #9e9e9e;">{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(row.item.CRMWhatsappContactPhoneNumber, false) }}</p>
                </div>
              </td>
              <td>
                <template v-if="row.item.CRMWhatsappConversationFirstCRMAgentID && systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationFirstCRMAgentID)">
                  <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationFirstCRMAgentID).CRMAgentColor || 'primary'" variant="flat" elevation="2" label>
                    <div style="display: flex; align-items: center;">
                      <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationFirstCRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" :draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <div style="display: flex; flex-direction: column;">
                        <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationFirstCRMAgentID).CRMAgentName || 'No registrado' }}</p>
                        <div style="display: flex; align-items: center; gap: 5px;">
                          <v-icon size="x-small">mdi-clock</v-icon>
                          <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappConversationStartDatetime) }}</p>
                        </div>
                      </div>
                    </div>
                  </v-chip>
                </template>
                <template v-else>
                  <v-chip color="primary" variant="flat" elevation="2" label>
                    <div style="display: flex; align-items: center;">
                      <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" :draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <div style="display: flex; flex-direction: column;">
                        <p>No registrado</p>
                        <div style="display: flex; align-items: center; gap: 5px;">
                          <v-icon size="x-small">mdi-clock</v-icon>
                          <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappConversationStartDatetime) }}</p>
                        </div>
                      </div>
                    </div>
                  </v-chip>
                </template>
              </td>
              <td>
                <template v-if="row.item.CRMWhatsappConversationCurrentCRMAgentID && systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationCurrentCRMAgentID)">
                  <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationCurrentCRMAgentID).CRMAgentColor || 'primary'" variant="flat" elevation="2" label>
                    <div style="display: flex; align-items: center;">
                      <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationCurrentCRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" :draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <div style="display: flex; flex-direction: column;">
                        <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationCurrentCRMAgentID).CRMAgentName || 'No registrado' }}</p>
                        <div style="display: flex; align-items: center; gap: 5px;">
                          <v-icon size="x-small">mdi-clock</v-icon>
                          <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappConversationEndDatetime) }}</p>
                        </div>
                      </div>
                    </div>
                  </v-chip>
                </template>
                <template v-else>
                  <v-chip color="primary" variant="flat" elevation="2" label>
                    <div style="display: flex; align-items: center;">
                      <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" :draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <div style="display: flex; flex-direction: column;">
                        <p>No registrado</p>
                        <div style="display: flex; align-items: center; gap: 5px;">
                          <v-icon size="x-small">mdi-clock</v-icon>
                          <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappConversationEndDatetime) }}</p>
                        </div>
                      </div>
                    </div>
                  </v-chip>
                </template>
              </td>
              <td>
                <p>{{ row.item.CRMWhatsappConversationEndDatetime == null || row.item.CRMWhatsappConversationStartDatetime == null ? 'No registrado' : $displayFunctions.default.fromMilisecondsToHHMMSS(new Date(row.item.CRMWhatsappConversationEndDatetime) - new Date(row.item.CRMWhatsappConversationStartDatetime)) }}</p>
              </td>
              <td>
                <p style="white-space: nowrap;">{{ row.item.CRMWhatsappConversationResult || 'No registrado' }}</p>
              </td>
              <td>
                <v-btn @click="$root.dialogComponent.openCRMWhatsappConversationDialog(row.item.CRMWhatsappConversationID, true, false, false, true, true, true, false, false, false, false, false, false)" color="primary" class="hoverableText">
                  <v-icon size="small" style="margin-right: 10px;">mdi-chat</v-icon>
                  <p style="font-size: small;">CONVERSACIÓN</p>
                </v-btn>
              </td>
              <td>
                <v-btn @click="$root.dialogComponent.openResumeCRMWhatsappConversationDialog(row.item.CRMWhatsappConversationID)" color="primary" class="hoverableText">
                  <v-icon size="small" style="margin-right: 10px;">mdi-chat-plus</v-icon>
                  <p style="font-size: small;">RETOMAR</p>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:loading>
            <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; padding: 30px;">
              <v-icon size="large" color="indigo">mdi-clock</v-icon>
              <p style="margin-top: 10px; color: grey;">Cargando lista de conversaciones...</p>
            </div>
          </template>
          <template v-slot:no-data>
            <div style="text-align: center; padding: 15px; cursor: default; user-select: none;">
              <v-icon size="large" color="indigo">mdi-information</v-icon>
              <p style="margin-top: 10px; color: grey;">No existen conversaciones en el rango de fecha seleccionado</p>
            </div>
          </template>
          <template v-slot:bottom></template>
        </v-data-table>
        <template v-if="display.CRMWhatsappConversationsSummary.CRMWhatsappConversationsCount != null && display.CRMWhatsappConversationsSummary.CRMWhatsappConversationsCount != 0">
          <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
          <v-card color="primary" elevation="0" rounded="0">
            <div class="dialogFooterContainer">
              <div class="summaryContainer">
                <div style="display: flex; align-items: center;">
                  <v-icon color="indigo" size="small" style="margin-right: 5px;">mdi-chat</v-icon>
                  <p style="font-size: small; margin-right: 10px;"><strong>Conversaciones: </strong>{{ display.CRMWhatsappConversationsSummary.CRMWhatsappConversationsCount }}</p>
                  <v-tooltip :disabled="display.offsetCRMWhatsappConversationsSummary.CRMWhatsappConversationsCount == 0" location="top">
                    <template v-slot:activator="{ props }">
                      <v-chip v-bind="props" :color="(display.offsetCRMWhatsappConversationsSummary.CRMWhatsappConversationsCount == 0 ? 'grey' : ((display.CRMWhatsappConversationsSummary.CRMWhatsappConversationsCount - display.offsetCRMWhatsappConversationsSummary.CRMWhatsappConversationsCount) / display.offsetCRMWhatsappConversationsSummary.CRMWhatsappConversationsCount) >= 0 ? 'error' : 'success')" variant="flat" size="small" elevation="2" label class="hoverableText">
                        <v-icon :icon="(display.offsetCRMWhatsappConversationsSummary.CRMWhatsappConversationsCount == 0 ? 'mdi-trending-neutral' : ((display.CRMWhatsappConversationsSummary.CRMWhatsappConversationsCount - display.offsetCRMWhatsappConversationsSummary.CRMWhatsappConversationsCount) / display.offsetCRMWhatsappConversationsSummary.CRMWhatsappConversationsCount) >= 0 ? 'mdi-trending-up' : 'mdi-trending-down')" size="small" start></v-icon>
                        <template v-if="display.offsetCRMWhatsappConversationsSummary.CRMWhatsappConversationsCount != 0">
                          <p style="font-size: x-small;"><strong>{{(((display.CRMWhatsappConversationsSummary.CRMWhatsappConversationsCount - display.offsetCRMWhatsappConversationsSummary.CRMWhatsappConversationsCount) / display.offsetCRMWhatsappConversationsSummary.CRMWhatsappConversationsCount) * 100).toFixed(2)}}%</strong></p>
                        </template>
                        <template v-else>
                          <p style="font-size: x-small;"><strong>Sin datos</strong></p>
                        </template>
                      </v-chip>
                    </template>
                    <div>
                      <p><strong>Conversaciones:</strong> {{ display.CRMWhatsappConversationsSummary.CRMWhatsappConversationsCount }}</p>
                      <p><strong>Conversaciones de comparación:</strong> {{ display.offsetCRMWhatsappConversationsSummary.CRMWhatsappConversationsCount }}</p>
                      <p><strong>Diferencia:</strong> {{ display.CRMWhatsappConversationsSummary.CRMWhatsappConversationsCount - display.offsetCRMWhatsappConversationsSummary.CRMWhatsappConversationsCount }}</p>
                    </div>
                  </v-tooltip>
                </div>
              </div>
              <div class="paginatorContainer">
                <v-pagination
                  v-model="input.CRMWhatsappConversationsPage"
                  @update:model-value="selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformation(false)"
                  :length="Math.ceil(display.CRMWhatsappConversationsSummary.CRMWhatsappConversationsCount / navigation.CRMWhatsappConversationsLimit)"
                  :total-visible="5"
                  :disabled="loader.selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformationPagination"
                  density="compact"
                  size="small"
                ></v-pagination>
                <p style="font-size: x-small;">{{ (display.CRMWhatsappConversationsSummary.CRMWhatsappConversationsCount == 0) ? `0 de 0 conversaciones` : `${(input.CRMWhatsappConversationsPage - 1) * navigation.CRMWhatsappConversationsLimit + 1} - ${Math.min(input.CRMWhatsappConversationsPage * navigation.CRMWhatsappConversationsLimit, display.CRMWhatsappConversationsSummary.CRMWhatsappConversationsCount)} de ${display.CRMWhatsappConversationsSummary.CRMWhatsappConversationsCount} ${display.CRMWhatsappConversationsSummary.CRMWhatsappConversationsCount > 1 ? 'conversaciones' : 'conversación'}`}}</p>
              </div>
            </div>
          </v-card>
        </template>
      </div>
    </v-card>
  </v-dialog>

  <v-card elevation="0" rounded="0" style="height: 100%; width: 100%; display: flex; flex-direction: column; user-select: none; cursor: default;">
    <v-card color="primary" elevation="0" rounded="0">
      <div class="inputContainer">
        <v-autocomplete
          ref="CRMAgentID"
          v-model="input.CRMAgentID"
          @keydown.enter.prevent="selectCRMDashboardCRMAgentSummaryInformation()"
          @update:model-value="display.CRMDashboardCRMAgentSummaryInformation = null;"
          :items="systemInformationData.CRMAgents"
          :loading="loader.selectCRMDashboardCRMAgentSummaryInformation"
          :disabled="loader.selectCRMDashboardCRMAgentSummaryInformation"
          color="indigo"
          item-title="CRMAgentName"
          item-value="CRMAgentID"
          label="Seleccionar agente"
          variant="outlined"
          density="compact"
          autocomplete="off"
          chips
          hide-details
        >
          <template v-slot:prepend-inner>
            <v-icon @click="$generalFunctions.default.blurInput(this, 'CRMAgentID'); input.CRMAgentID = 'null';" color="indigo">{{ input.CRMAgentID ? 'mdi-briefcase-off' : 'mdi-briefcase-account' }}</v-icon>
          </template>
          <template v-slot:item="{ props, item }">
            <v-list-item v-bind="props" :title="null" :subtitle="null" style="cursor: pointer;">
              <v-chip :color="item.raw.CRMAgentColor" variant="flat" elevation="2" label>
                <div style="display: flex; align-items: center;">
                  <template v-if="item.raw.CRMAgentID != 'null'">
                    <img :src="item.raw.CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;"/>
                  </template>
                  <span>{{ item.raw.CRMAgentName }}</span>
                </div>
              </v-chip>
            </v-list-item>
          </template>
          <template v-slot:chip="{ props, item }">
            <v-chip v-bind="props" :color="item.raw.CRMAgentColor" variant="flat" elevation="2" label>
              <div style="display: flex; align-items: center;">
                <template v-if="item.raw.CRMAgentID != 'null'">
                  <img :src="item.raw.CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;"/>
                </template>
                <span>{{ item.raw.CRMAgentName }}</span>
              </div>
              <template v-slot:close>
                <v-icon @click.stop="input.CRMAgentID = 'null'; $generalFunctions.default.blurInput(this, 'CRMAgentID');">mdi-close-circle</v-icon>
              </template>
            </v-chip>
          </template>
        </v-autocomplete>
        <v-date-input
          ref="date"
          v-model="input.date"
          @keydown.enter.prevent="selectCRMDashboardCRMAgentSummaryInformation()"
          @update:model-value="display.CRMDashboardCRMAgentSummaryInformation = null;"
          :disabled="loader.selectCRMDashboardCRMAgentSummaryInformation"
          :loading="loader.selectCRMDashboardCRMAgentSummaryInformation"
          color="indigo"
          prepend-icon=""
          display="keyboardDate"
          label="Filtrar por fecha"
          variant="outlined"
          density="compact"
          multiple="range"
          autocomplete="off"
          min="2025-01-01"
          :max="new Date().toISOString().split('T')[0]"
          hide-details
        >
          <template v-slot:prepend-inner>
            <v-icon @click="$generalFunctions.default.blurInput(this, 'date'); input.date = [new Date()];" color="indigo">{{ input.date.length > 0 ? 'mdi-calendar-remove' : 'mdi-calendar' }}</v-icon>
          </template>              
        </v-date-input>
        <v-btn 
          @click="selectCRMDashboardCRMAgentSummaryInformation()" 
          :disabled="loader.selectCRMDashboardCRMAgentSummaryInformation" 
          color="indigo"
          block
          class="hoverableText"
        >
          <v-icon style="margin-right: 10px;">mdi-magnify</v-icon>
          <h3>BUSCAR</h3>
        </v-btn>
      </div>
      <template v-if="display.CRMDashboardCRMAgentSummaryInformation">
        <div style="text-align: center; padding-bottom: 10px;">
          <p style="font-size: small; color: #9e9e9e;"><strong>Fecha de comparación:</strong> del {{ $displayFunctions.default.fromDatetimeToDDMMYYYY(display.CRMDashboardCRMAgentSummaryInformation.offsetStartDate) }} al {{ $displayFunctions.default.fromDatetimeToDDMMYYYY(display.CRMDashboardCRMAgentSummaryInformation.offsetEndDate) }}</p>
        </div>
      </template>
    </v-card>
    <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
    <div style="flex: 1 0 0; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none; padding: 15px; gap: 15px;">
      <template v-if="display.CRMDashboardCRMAgentSummaryInformation == null">
        <template v-if="loader.selectCRMDashboardCRMAgentSummaryInformation">
          <div style="height: 100%; width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; padding: 15px; gap: 10px;">
            <v-progress-circular indeterminate color="indigo"></v-progress-circular>
            <div style="display: flex; flex-direction: row; align-items: center; gap: 10px;">
              <p style="margin-top: 5px; color: grey;">Cargando resumen {{ input.CRMAgentID != 'null' ? 'de' : ''}}</p>
              <template v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == input.CRMAgentID)">
                <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == input.CRMAgentID).CRMAgentColor || 'primary'" variant="flat" elevation="2" label>
                  <div style="display: flex; align-items: center;">
                    <template v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == input.CRMAgentID).CRMAgentID != 'null'">
                      <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == input.CRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;"/>
                    </template>
                    <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == input.CRMAgentID).CRMAgentName }}</p>
                  </div>
                </v-chip>
              </template>
              <template v-else>
                <p>agente</p>
              </template>
            </div>
          </div>
        </template>
        <template v-else>
          <div style="height: 100%; width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; padding: 15px; gap: 10px;">
            <v-icon size="large" color="indigo">mdi-information</v-icon>
            <p style="color: grey;">Seleccione un agente y un rango de fechas, luego presione "BUSCAR" para obtener el resumen del agente</p>
          </div>
        </template>
      </template>
      <template v-else>
        <div class="fourColumnContainer">
          <v-card color="borderInner">
            <v-card color="primary" elevation="0" rounded="0" style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
              <v-icon size="small" color="indigo">mdi-message-text-clock</v-icon>
              <h4>TIEMPO DE RESPUESTA</h4>
              <v-tooltip :disabled="systemInformationData.tooltipDisabled" location="top">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" color="indigo" size="x-small" class="hoverableElement">mdi-information</v-icon>
                </template>
                <span style="max-width: 400px; display: block;">El tiempo de respuesta promedio es calculado en base a las conversaciones finalizadas en el rango de fechas seleccionado. Considera el tiempo que tarda el agente en responder a los mensajes enviados por los clientes</span>
              </v-tooltip>
            </v-card>
            <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
            <div style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
              <p>{{ $displayFunctions.default.fromSecondsToHHMMSS(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationAverageResponseTime.CRMWhatsappConversationAverageResponseTime) }}</p>              
              <v-tooltip :disabled="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationAverageResponseTime.offsetCRMWhatsappConversationAverageResponseTime == 0" location="top">
                <template v-slot:activator="{ props }">
                  <v-chip v-bind="props" :color="(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationAverageResponseTime.offsetCRMWhatsappConversationAverageResponseTime == 0 ? 'primary' : ((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationAverageResponseTime.CRMWhatsappConversationAverageResponseTime - display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationAverageResponseTime.offsetCRMWhatsappConversationAverageResponseTime) / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationAverageResponseTime.offsetCRMWhatsappConversationAverageResponseTime) >= 0 ? 'success' : 'error')" variant="flat" elevation="2" label class="hoverableText">
                    <v-icon :icon="(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationAverageResponseTime.offsetCRMWhatsappConversationAverageResponseTime == 0 ? 'mdi-trending-neutral' : ((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationAverageResponseTime.CRMWhatsappConversationAverageResponseTime - display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationAverageResponseTime.offsetCRMWhatsappConversationAverageResponseTime) / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationAverageResponseTime.offsetCRMWhatsappConversationAverageResponseTime) >= 0 ? 'mdi-trending-up' : 'mdi-trending-down')" size="small" start></v-icon>
                    <template v-if="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationAverageResponseTime.offsetCRMWhatsappConversationAverageResponseTime != 0">
                      <p style="font-size: small;"><strong>{{(((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationAverageResponseTime.CRMWhatsappConversationAverageResponseTime - display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationAverageResponseTime.offsetCRMWhatsappConversationAverageResponseTime) / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationAverageResponseTime.offsetCRMWhatsappConversationAverageResponseTime) * 100).toFixed(2)}}%</strong></p>
                    </template>
                    <template v-else>
                      <p style="font-size: small;"><strong>Sin datos</strong></p>
                    </template>
                  </v-chip>
                </template>
                <div>
                  <p><strong>Tiempo de respuesta promedio:</strong> {{ $displayFunctions.default.fromSecondsToHHMMSS(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationAverageResponseTime.CRMWhatsappConversationAverageResponseTime) }}</p>
                  <p><strong>Tiempo de respuesta promedio de comparación:</strong> {{ $displayFunctions.default.fromSecondsToHHMMSS(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationAverageResponseTime.offsetCRMWhatsappConversationAverageResponseTime) }}</p>
                  <p><strong>Diferencia:</strong> {{ $displayFunctions.default.fromSecondsToHHMMSS(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationAverageResponseTime.CRMWhatsappConversationAverageResponseTime - display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationAverageResponseTime.offsetCRMWhatsappConversationAverageResponseTime) }}</p>
                </div>
              </v-tooltip>
            </div>
          </v-card>
          <v-card color="borderInner">
            <v-card color="primary" elevation="0" rounded="0" style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
              <v-icon size="small" color="indigo">mdi-clock</v-icon>
              <h4>TIEMPO EN LÍNEA</h4>
              <v-tooltip :disabled="systemInformationData.tooltipDisabled" location="top">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" color="indigo" size="x-small" class="hoverableElement">mdi-information</v-icon>
                </template>
                <span style="max-width: 400px; display: block;">El tiempo en línea es calculado en base a los intervalos de tiempo en los que el agente estuvo activo durante el rango de fechas seleccionado</span>
              </v-tooltip>
            </v-card>
            <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
            <template v-if="input.CRMAgentID == 'null'">
              <div style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
                <p>No disponible</p>
              </div>
            </template>
            <template v-else>
              <div style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
                <p>{{ $displayFunctions.default.fromMilisecondsToHHMMSS(display.CRMDashboardCRMAgentSummaryInformation.CRMAgentOnlineTime) }}</p>              
                <v-tooltip :disabled="display.CRMDashboardCRMAgentSummaryInformation.offsetCRMAgentOnlineTime == 0" location="top">
                  <template v-slot:activator="{ props }">
                    <v-chip v-bind="props" :color="(display.CRMDashboardCRMAgentSummaryInformation.offsetCRMAgentOnlineTime == 0 ? 'primary' : ((display.CRMDashboardCRMAgentSummaryInformation.CRMAgentOnlineTime - display.CRMDashboardCRMAgentSummaryInformation.offsetCRMAgentOnlineTime) / display.CRMDashboardCRMAgentSummaryInformation.offsetCRMAgentOnlineTime) >= 0 ? 'success' : 'error')" variant="flat" label elevation="2" class="hoverableText">
                      <v-icon :icon="(display.CRMDashboardCRMAgentSummaryInformation.offsetCRMAgentOnlineTime == 0 ? 'mdi-trending-neutral' : ((display.CRMDashboardCRMAgentSummaryInformation.CRMAgentOnlineTime - display.CRMDashboardCRMAgentSummaryInformation.offsetCRMAgentOnlineTime) / display.CRMDashboardCRMAgentSummaryInformation.offsetCRMAgentOnlineTime) >= 0 ? 'mdi-trending-up' : 'mdi-trending-down')" size="small" start></v-icon>
                      <template v-if="display.CRMDashboardCRMAgentSummaryInformation.offsetCRMAgentOnlineTime != 0">
                        <p style="font-size: small;"><strong>{{(((display.CRMDashboardCRMAgentSummaryInformation.CRMAgentOnlineTime - display.CRMDashboardCRMAgentSummaryInformation.offsetCRMAgentOnlineTime) / display.CRMDashboardCRMAgentSummaryInformation.offsetCRMAgentOnlineTime) * 100).toFixed(2)}}%</strong></p>
                      </template>
                      <template v-else>
                        <p style="font-size: small;"><strong>Sin datos</strong></p>
                      </template>
                    </v-chip>
                  </template>
                  <div>
                    <p><strong>Tiempo en línea promedio:</strong> {{ $displayFunctions.default.fromMilisecondsToHHMMSS(display.CRMDashboardCRMAgentSummaryInformation.CRMAgentOnlineTime) }}</p>
                    <p><strong>Tiempo en línea promedio de comparación:</strong> {{ $displayFunctions.default.fromMilisecondsToHHMMSS(display.CRMDashboardCRMAgentSummaryInformation.offsetCRMAgentOnlineTime) }}</p>
                    <p><strong>Diferencia:</strong> {{ $displayFunctions.default.fromMilisecondsToHHMMSS(display.CRMDashboardCRMAgentSummaryInformation.CRMAgentOnlineTime - display.CRMDashboardCRMAgentSummaryInformation.offsetCRMAgentOnlineTime) }}</p>
                  </div>
                </v-tooltip>
              </div>
            </template>
          </v-card>
          <v-card color="borderInner">
            <v-card color="primary" elevation="0" rounded="0" style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
              <v-icon size="small" color="indigo">mdi-chat</v-icon>
              <h4>CONVERSACIONES</h4>
              <v-tooltip :disabled="systemInformationData.tooltipDisabled" location="top">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" color="indigo" size="x-small" class="hoverableElement">mdi-information</v-icon>
                </template>
                <span style="max-width: 400px; display: block;">Cantidad de conversaciones con clientes únicos finalizadas por el agente en el rango de fechas seleccionado</span>
              </v-tooltip>
            </v-card>
            <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
            <div style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
              <p>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.CRMWhatsappConversationCount.newCRMWhatsappConversationCount + display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.CRMWhatsappConversationCount.previousCRMWhatsappConversationCount) }}</p>              
              <v-tooltip :disabled="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount + display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.previousCRMWhatsappConversationCount == 0" location="top">
                <template v-slot:activator="{ props }">
                  <v-chip v-bind="props" :color="(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount + display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.previousCRMWhatsappConversationCount == 0) ? 'primary' : ((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.CRMWhatsappConversationCount.newCRMWhatsappConversationCount + display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.CRMWhatsappConversationCount.previousCRMWhatsappConversationCount - display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount - display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.previousCRMWhatsappConversationCount) / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount + display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.previousCRMWhatsappConversationCount) >= 0 ? 'success' : 'error'" variant="flat" elevation="2" label class="hoverableText">
                    <v-icon :icon="(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount + display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.previousCRMWhatsappConversationCount == 0) ? 'mdi-trending-neutral' : ((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.CRMWhatsappConversationCount.newCRMWhatsappConversationCount + display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.CRMWhatsappConversationCount.previousCRMWhatsappConversationCount - display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount - display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.previousCRMWhatsappConversationCount) / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount + display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.previousCRMWhatsappConversationCount) >= 0 ? 'mdi-trending-up' : 'mdi-trending-down'" size="small" start></v-icon>
                    <template v-if="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount + display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.previousCRMWhatsappConversationCount != 0">
                      <p style="font-size: small;"><strong>{{((((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.CRMWhatsappConversationCount.newCRMWhatsappConversationCount + display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.CRMWhatsappConversationCount.previousCRMWhatsappConversationCount) - (display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount + display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.previousCRMWhatsappConversationCount)) / (display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount + display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.previousCRMWhatsappConversationCount)) * 100).toFixed(2)}}%</strong></p>
                    </template>
                    <template v-else>
                      <p style="font-size: small;"><strong>Sin datos</strong></p>
                    </template>
                  </v-chip>
                </template>
                <div>
                  <p><strong>Cantidad de conversaciones:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.CRMWhatsappConversationCount.newCRMWhatsappConversationCount + display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.CRMWhatsappConversationCount.previousCRMWhatsappConversationCount) }}</p>
                  <p><strong>Cantidad de conversaciones de comparación:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount + display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.previousCRMWhatsappConversationCount) }}</p>
                  <p><strong>Diferencia:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.CRMWhatsappConversationCount.newCRMWhatsappConversationCount + display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.CRMWhatsappConversationCount.previousCRMWhatsappConversationCount - display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount - display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.previousCRMWhatsappConversationCount) }}</p>
                </div>
              </v-tooltip>
            </div>
          </v-card>
          <v-card color="borderInner">
            <v-card color="primary" elevation="0" rounded="0" style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
              <v-icon size="small" color="indigo">mdi-chat-plus</v-icon>
              <h4>NUEVOS CONTACTOS</h4>
              <v-tooltip :disabled="systemInformationData.tooltipDisabled" location="top">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" color="indigo" size="x-small" class="hoverableElement">mdi-information</v-icon>
                </template>
                <span style="max-width: 400px; display: block;">Cantidad de conversaciones con contactos nuevos que el agente ha finalizado en el rango de fechas seleccionado</span>
              </v-tooltip>
            </v-card>
            <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
            <div style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
              <p>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.CRMWhatsappConversationCount.newCRMWhatsappConversationCount) }}</p>              
              <v-tooltip :disabled="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount == 0" location="top">
                <template v-slot:activator="{ props }">
                  <v-chip v-bind="props" :color="(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount == 0 ? 'primary' : ((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.CRMWhatsappConversationCount.newCRMWhatsappConversationCount - display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount) / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount) >= 0 ? 'success' : 'error')" variant="flat" elevation="2" label class="hoverableText">
                    <v-icon :icon="(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount == 0 ? 'mdi-trending-neutral' : ((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.CRMWhatsappConversationCount.newCRMWhatsappConversationCount - display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount) / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount) >= 0 ? 'mdi-trending-up' : 'mdi-trending-down')" size="small" start></v-icon>
                    <template v-if="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount != 0">
                      <p style="font-size: small;"><strong>{{(((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.CRMWhatsappConversationCount.newCRMWhatsappConversationCount - display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount) / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount) * 100).toFixed(2)}}%</strong></p>
                    </template>
                    <template v-else>
                      <p style="font-size: small;"><strong>Sin datos</strong></p>
                    </template>
                  </v-chip>
                </template>
                <div>
                  <p><strong>Cantidad de conversaciones:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.CRMWhatsappConversationCount.newCRMWhatsappConversationCount) }}</p>
                  <p><strong>Cantidad de conversaciones de comparación:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount) }}</p>
                  <p><strong>Diferencia:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.CRMWhatsappConversationCount.newCRMWhatsappConversationCount - display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.offsetCRMWhatsappConversationCount.newCRMWhatsappConversationCount) }}</p>
                </div>
              </v-tooltip>
            </div>
          </v-card>
        </div>
        <div class="fourColumnContainer" style="margin-top: 15px;">
          <v-card color="borderInner">
            <v-card color="primary" elevation="0" rounded="0" style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
              <v-icon size="small" color="indigo">mdi-invoice-text</v-icon>
              <h4>ÓRDENES</h4>
              <v-tooltip :disabled="systemInformationData.tooltipDisabled" location="top">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" color="indigo" size="x-small" class="hoverableElement">mdi-information</v-icon>
                </template>
                <span style="max-width: 400px; display: block;">Cantidad de órdenes generadas por el agente en el rango de fechas seleccionado</span>
              </v-tooltip>
            </v-card>
            <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
            <div style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
              <p>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceCount) }}</p>              
              <v-tooltip :disabled="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceCount == 0" location="top">
                <template v-slot:activator="{ props }">
                  <v-chip v-bind="props" :color="(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceCount == 0 ? 'primary' : ((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceCount - display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceCount) / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceCount) >= 0 ? 'success' : 'error')" variant="flat" elevation="2" label class="hoverableText">
                    <v-icon :icon="(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceCount == 0 ? 'mdi-trending-neutral' : ((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceCount - display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceCount) / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceCount) >= 0 ? 'mdi-trending-up' : 'mdi-trending-down')" size="small" start></v-icon>
                    <template v-if="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceCount != 0">
                      <p style="font-size: small;"><strong>{{(((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceCount - display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceCount) / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceCount) * 100).toFixed(2)}}%</strong></p>
                    </template>
                    <template v-else>
                      <p style="font-size: small;"><strong>Sin datos</strong></p>
                    </template>
                  </v-chip>
                </template>
                <div>
                  <p><strong>Cantidad de órdenes:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceCount) }}</p>
                  <p><strong>Cantidad de órdenes de comparación:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceCount) }}</p>
                  <p><strong>Diferencia de órdenes:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceCount - display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceCount) }}</p>
                </div>
              </v-tooltip>
            </div>
          </v-card>
          <v-card color="borderInner">
            <v-card color="primary" elevation="0" rounded="0" style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
              <v-icon size="small" color="indigo">mdi-cash-multiple</v-icon>
              <h4>VENTAS</h4>
              <v-tooltip :disabled="systemInformationData.tooltipDisabled" location="top">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" color="indigo" size="x-small" class="hoverableElement">mdi-information</v-icon>
                </template>
                <span style="max-width: 400px; display: block;">Cantidad de ventas generadas por el agente en el rango de fechas seleccionado</span>
              </v-tooltip>
            </v-card>
            <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
            <div style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
              <div style="display: flex; align-items: center;">
                <p style="color: #3F51B5; margin-right: 5px;"><strong>₡</strong></p>
                <p>{{ $displayFunctions.default.parseAmountToDisplay(Math.round(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceAmount / 5) * 5) }}</p>
              </div>
              <v-tooltip :disabled="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount == 0" location="top">
                <template v-slot:activator="{ props }">
                  <v-chip v-bind="props" :color="(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount == 0 ? 'primary' : ((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceAmount - display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount) / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount) >= 0 ? 'success' : 'error')" variant="flat" elevation="2" label class="hoverableText">
                    <v-icon :icon="(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount == 0 ? 'mdi-trending-neutral' : ((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceAmount - display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount) / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount) >= 0 ? 'mdi-trending-up' : 'mdi-trending-down')" size="small" start></v-icon>
                    <template v-if="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount != 0">
                      <p style="font-size: small;"><strong>{{(((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceAmount - display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount) / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount) * 100).toFixed(2)}}%</strong></p>
                    </template>
                    <template v-else>
                      <p style="font-size: small;"><strong>Sin datos</strong></p>
                    </template>
                  </v-chip>
                </template>
                <div>
                  <p><strong>Monto de venta:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceAmount / 5) * 5) }}</p>
                  <p><strong>Monto de venta de comparación:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount / 5) * 5) }}</p>
                  <p><strong>Diferencia de venta:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceAmount - display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount) / 5) * 5) }}</p>
                </div>
              </v-tooltip>
            </div>
          </v-card>
          <v-card color="borderInner">
            <v-card color="primary" elevation="0" rounded="0" style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
              <v-icon size="small" color="indigo">mdi-percent</v-icon>
              <h4>TICKET PROMEDIO</h4>
              <v-tooltip :disabled="systemInformationData.tooltipDisabled" location="top">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" color="indigo" size="x-small" class="hoverableElement">mdi-information</v-icon>
                </template>
                <span style="max-width: 400px; display: block;">El ticket promedio se calcula en base al monto de venta total dividido por la cantidad de órdenes en el rango de fechas seleccionado</span>
              </v-tooltip>
            </v-card>
            <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
            <div style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
              <div style="display: flex; align-items: center;">
                <p style="color: #3F51B5; margin-right: 5px;"><strong>₡</strong></p>
                <template v-if="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceCount != 0">
                  <p>{{ $displayFunctions.default.parseAmountToDisplay(Math.round((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceAmount / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceCount) / 5) * 5) }}</p>
                </template>
                <template v-else>
                  <p>{{ $displayFunctions.default.parseAmountToDisplay(0) }}</p>
                </template>
              </div>
              <v-tooltip :disabled="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount == 0" location="top">
                <template v-slot:activator="{ props }">
                  <v-chip v-bind="props" :color="(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount == 0 ? 'primary' : (((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceAmount / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceCount) - (display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceCount)) / (display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceCount)) >= 0 ? 'success' : 'error')" variant="flat" elevation="2" label class="hoverableText">
                    <v-icon :icon="(display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount == 0 ? 'mdi-trending-neutral' : (((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceAmount / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceCount) - (display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceCount)) / (display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceCount)) >= 0 ? 'mdi-trending-up' : 'mdi-trending-down')" size="small" start></v-icon>
                    <template v-if="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount != 0">
                      <p style="font-size: small;"><strong>{{((((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceAmount / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceCount) - (display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceCount)) / (display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceCount)) * 100).toFixed(2)}}%</strong></p>
                    </template>
                    <template v-else>
                      <p style="font-size: small;"><strong>Sin datos</strong></p>
                    </template>
                  </v-chip>
                </template>
                <div>
                  <p><strong>Ticket promedio:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceAmount / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceCount) / 5) * 5) }}</p>
                  <p><strong>Ticket promedio de comparación:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceCount) / 5) * 5) }}</p>
                  <p><strong>Diferencia de ticket promedio:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round(((display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceAmount / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceCount) - (display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceAmount / display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.offsetCRMWhatsappInvoices.CRMWhatsappInvoiceCount)) / 5) * 5) }}</p>
                </div>
              </v-tooltip>
            </div>
          </v-card>
          <v-card color="borderInner">
            <v-card color="primary" elevation="0" rounded="0" style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
              <v-icon size="small" color="indigo">mdi-invoice-text-plus</v-icon>
              <h4>NUEVAS ÓRDENES</h4>
              <v-tooltip :disabled="systemInformationData.tooltipDisabled" location="top">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" color="indigo" size="x-small" class="hoverableElement">mdi-information</v-icon>
                </template>
                <span style="max-width: 400px; display: block;">Cantidad de órdenes con contactos nuevos que el agente ha generado en el rango de fechas seleccionado</span>
              </v-tooltip>
            </v-card>
            <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
            <div style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
              <p>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.CRMDashboardCRMAgentSummaryInformation.newCRMWhatsappInvoiceCount.newCRMWhatsappInvoiceCount) }}</p>              
              <v-tooltip :disabled="display.CRMDashboardCRMAgentSummaryInformation.newCRMWhatsappInvoiceCount.offsetNewCRMWhatsappInvoiceCount == 0" location="top">
                <template v-slot:activator="{ props }">
                  <v-chip v-bind="props" :color="(display.CRMDashboardCRMAgentSummaryInformation.newCRMWhatsappInvoiceCount.offsetNewCRMWhatsappInvoiceCount == 0 ? 'primary' : ((display.CRMDashboardCRMAgentSummaryInformation.newCRMWhatsappInvoiceCount.newCRMWhatsappInvoiceCount - display.CRMDashboardCRMAgentSummaryInformation.newCRMWhatsappInvoiceCount.offsetNewCRMWhatsappInvoiceCount) / display.CRMDashboardCRMAgentSummaryInformation.newCRMWhatsappInvoiceCount.offsetNewCRMWhatsappInvoiceCount) >= 0 ? 'success' : 'error')" variant="flat" elevation="2" label class="hoverableText">
                    <v-icon :icon="(display.CRMDashboardCRMAgentSummaryInformation.newCRMWhatsappInvoiceCount.offsetNewCRMWhatsappInvoiceCount == 0 ? 'mdi-trending-neutral' : ((display.CRMDashboardCRMAgentSummaryInformation.newCRMWhatsappInvoiceCount.newCRMWhatsappInvoiceCount - display.CRMDashboardCRMAgentSummaryInformation.newCRMWhatsappInvoiceCount.offsetNewCRMWhatsappInvoiceCount) / display.CRMDashboardCRMAgentSummaryInformation.newCRMWhatsappInvoiceCount.offsetNewCRMWhatsappInvoiceCount) >= 0 ? 'mdi-trending-up' : 'mdi-trending-down')" size="small" start></v-icon>
                    <template v-if="display.CRMDashboardCRMAgentSummaryInformation.newCRMWhatsappInvoiceCount.offsetNewCRMWhatsappInvoiceCount != 0">
                      <p style="font-size: small;"><strong>{{(((display.CRMDashboardCRMAgentSummaryInformation.newCRMWhatsappInvoiceCount.newCRMWhatsappInvoiceCount - display.CRMDashboardCRMAgentSummaryInformation.newCRMWhatsappInvoiceCount.offsetNewCRMWhatsappInvoiceCount) / display.CRMDashboardCRMAgentSummaryInformation.newCRMWhatsappInvoiceCount.offsetNewCRMWhatsappInvoiceCount) * 100).toFixed(2)}}%</strong></p>
                    </template>
                    <template v-else>
                      <p style="font-size: small;"><strong>Sin datos</strong></p>
                    </template>
                  </v-chip>
                </template>
                <div>
                  <p><strong>Cantidad de órdenes:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.CRMDashboardCRMAgentSummaryInformation.newCRMWhatsappInvoiceCount.CRMWhatsappInvoiceCount) }}</p>
                  <p><strong>Cantidad de órdenes de comparación:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.CRMDashboardCRMAgentSummaryInformation.newCRMWhatsappInvoiceCount.offsetNewCRMWhatsappInvoiceCount) }}</p>
                  <p><strong>Diferencia:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(display.CRMDashboardCRMAgentSummaryInformation.newCRMWhatsappInvoiceCount.newCRMWhatsappInvoiceCount - display.CRMDashboardCRMAgentSummaryInformation.newCRMWhatsappInvoiceCount.offsetNewCRMWhatsappInvoiceCount) }}</p>
                </div>
              </v-tooltip>
            </div>
          </v-card>
        </div>
        <div class="notEvenlyDistributedTwoColumnContainer" style="margin-top: 15px;">
          <v-card color="borderInner" style="min-height: 300px; display: flex; flex-direction: column; position: relative;">
            <v-card color="primary" elevation="0" rounded="0" style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
              <v-icon size="small" color="indigo">mdi-chat</v-icon>
              <h4>GENERACIÓN DE ÓRDENES</h4>
            </v-card>
            <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
            <div style="flex: 1; width: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center;">
              <template v-if="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCountChartOptions && display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCountChartSeries">
                <apexchart 
                  @dataPointSelection="clickOnCRMWhatsappConversationCountChart"
                  :series="input.CRMWhatsappConversationCountChartType == 'total' ? display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCountChartSeries : display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCountChartSeriesNC" 
                  :options="input.CRMWhatsappConversationCountChartType == 'total' ? display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCountChartOptions : display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCountChartOptionsNC" 
                  type="donut"
                  height="100%" 
                  width="100%"
                  style="cursor: pointer;"
                ></apexchart>
              </template>
            </div>
            <div style="margin-top: auto; width: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center;">
              <v-checkbox-btn 
                v-model="input.CRMWhatsappConversationCountChartType" 
                label="Solo nuevos contactos"
                true-value="NC"
                false-value="total"
                color="indigo"
                density="compact"
                size="small"
                hide-details
              />
            </div>
          </v-card>
          <v-card color="borderInner" style="max-height: 300px; display: flex; flex-direction: column;">
            <v-card color="primary" elevation="0" rounded="0" style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
              <v-icon size="small" color="indigo">mdi-circle</v-icon>
              <h4>ESTADO</h4>
            </v-card>
            <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
            <div style="flex: 1; width: 100%; padding: 5px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">
              <v-data-table 
                :items="display.CRMDashboardCRMAgentSummaryInformation.CRMAgentStatusChanges.slice().filter(CRMAgentStatusChange => CRMAgentStatusChange.isOffset == false)"
                :headers="display.CRMAgentStatusChangeHeaders"
                :items-per-page="-1"
                density="compact"
                fixed-header
                hover
                style="height: 100%;"
              >
                <template v-slot:header.CRMAgentStatusChangeID>
                  <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
                    <v-icon size="small" color="indigo">mdi-barcode</v-icon>
                    <p><strong>ID</strong></p>
                  </div>
                </template>
                <template v-slot:header.CRMAgentStatusChangeStatus>
                  <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
                    <v-icon size="small" color="indigo">mdi-circle</v-icon>
                    <p><strong>ESTADO</strong></p>
                  </div>
                </template>
                <template v-slot:header.CRMAgentStatusChangeDatetime>
                  <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
                    <v-icon size="small" color="indigo">mdi-calendar</v-icon>
                    <p><strong>FECHA</strong></p>
                  </div>
                </template>
                <template v-slot:header.CRMAgentStatusChangeDuration>
                  <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
                    <v-icon size="small" color="indigo">mdi-clock</v-icon>
                    <p><strong>DURACIÓN</strong></p>
                  </div>
                </template>
                <template v-slot:item.CRMAgentStatusChangeID="{ item }">
                  <v-hover v-slot="{ isHovering, props: hoverProps }">
                    <template v-if="isHovering == true && !systemInformationData.tooltipDisabled">
                      <v-tooltip v-bind="hoverProps" text="Copiar ID al portapapeles" location="top">
                        <template v-slot:activator="{ props: tooltipProps }">
                          <p v-bind="tooltipProps" @click="$generalFunctions.default.copyToClipboard(this, 'ID del cambio de estado del agente', 'o', item.CRMAgentStatusChangeID)" class="hoverableText" style="color: #3F51B5;"><strong>{{ item.CRMAgentStatusChangeID }}</strong></p>
                        </template>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      <p v-bind="hoverProps" @click="$generalFunctions.default.copyToClipboard(this, 'ID del cambio de estado del agente', 'o', item.CRMAgentStatusChangeID)" class="hoverableText" style="color: #3F51B5;"><strong>{{ item.CRMAgentStatusChangeID }}</strong></p>
                    </template>
                  </v-hover>
                </template>
                <template v-slot:item.CRMAgentStatusChangeStatus="{ item }">
                  <v-icon :color="item.CRMAgentStatusChangeStatus == 'active' ? 'success' : 'error'" size="small">mdi-circle</v-icon>
                </template>
                <template v-slot:item.CRMAgentStatusChangeDatetime="{ item }">
                  <p>{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(item.CRMAgentStatusChangeDatetime) }}</p>
                </template>
                <template v-slot:item.CRMAgentStatusChangeDuration="{ item, index }">
                  <template v-if="index < display.CRMDashboardCRMAgentSummaryInformation.CRMAgentStatusChanges.slice().filter(CRMAgentStatusChange => CRMAgentStatusChange.isOffset == false).length - 1">
                    <p>{{ $displayFunctions.default.fromMilisecondsToHHMMSS(new Date(display.CRMDashboardCRMAgentSummaryInformation.CRMAgentStatusChanges.slice().filter(CRMAgentStatusChange => CRMAgentStatusChange.isOffset == false)[index + 1].CRMAgentStatusChangeDatetime) - new Date(item.CRMAgentStatusChangeDatetime)) }}</p>
                  </template>
                  <template v-else>
                    <p>No registrado</p>
                  </template>
                </template>
                <template v-slot:no-data>
                  <div style="text-align: center; padding: 15px; cursor: default; user-select: none;">
                    <v-icon size="large" color="indigo">mdi-information</v-icon>
                    <p style="margin-top: 5px; color: #9e9e9e;">{{ input.CRMAgentID == 'null' ? 'No disponible' : 'No existen cambios de estado para este agente en el rango de fecha seleccionado' }}</p>
                  </div>
                </template>
                <template v-slot:bottom></template>
              </v-data-table>
            </div>
          </v-card>  
        </div>

        <div class="threeColumnContainer" style="margin-top: 15px;">
          <v-card color="borderInner" style="min-height: 300px; display: flex; flex-direction: column;">
            <v-card color="primary" elevation="0" rounded="0" style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
              <v-icon size="small" color="indigo">mdi-source-branch-check</v-icon>
              <h4>SEGUIMIENTOS DE CONTACTO</h4>
            </v-card>
            <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
            <div style="flex: 1; width: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center;">
              <template v-if="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappContactFollowupCountChartOptions && display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappContactFollowupCountChartSeries">
                <apexchart 
                  @dataPointSelection="clickOnCRMWhatsappContactFollowupCountChart"
                  :series="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappContactFollowupCountChartSeries" 
                  :options="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappContactFollowupCountChartOptions" 
                  type="donut"
                  height="100%" 
                  width="100%"
                  style="cursor: pointer;"
                ></apexchart>
              </template>
            </div>
          </v-card>
          <v-card color="borderInner" style="min-height: 300px; display: flex; flex-direction: column;">
            <v-card color="primary" elevation="0" rounded="0" style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
              <v-icon size="small" color="indigo">mdi-package</v-icon>
              <h4>UNIDADES POR CATEGORÍA</h4>
            </v-card>
            <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
            <div style="flex: 1; width: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center;">
              <template v-if="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceProductAmountChartOptions && display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceProductAmountChartSeries">
                <apexchart 
                  @dataPointSelection="clickOnCRMWhatsappInvoiceProductAmountChart"
                  :series="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceProductAmountChartSeries" 
                  :options="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceProductAmountChartOptions" 
                  type="donut"
                  height="100%" 
                  width="100%"
                  style="cursor: pointer;"
                ></apexchart>
              </template>
            </div>
          </v-card>
          
          
          <v-card color="borderInner" style="min-height: 300px; display: flex; flex-direction: column;">
            <v-card color="primary" elevation="0" rounded="0" style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
              <v-icon size="small" color="indigo">mdi-clock</v-icon>
              <h4>VENTAS POR HORA</h4>
            </v-card>
            <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
            <div style="width: 100%; display: flex; flex-direction: column;">
              <template v-if="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceCountChartOptions && display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceCountChartSeries">
                <apexchart 
                  @click="clickOnCRMWhatsappInvoiceCountChart"
                  :series="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceCountChartSeries" 
                  :options="display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceCountChartOptions" 
                  type="area"
                  height="300" 
                  width="100%"
                  style="cursor: pointer;"
                ></apexchart>
              </template>
            </div>
          </v-card>
        </div>

        

        <v-card color="borderInner" style="margin-top: 15px;">
          <v-card color="primary" elevation="0" rounded="0" style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px; padding: 10px;">
            <v-icon size="small" color="indigo">mdi-invoice-text</v-icon>
            <h4>TOP ÓRDENES</h4>
          </v-card>
          <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
          <div style="padding: 5px;">
            <v-data-table 
              :items="display.CRMDashboardCRMAgentSummaryInformation.topCRMWhatsappInvoices" 
              :headers="computed_topCRMWhatsappInvoicesHeaders" 
              :fixed-header="true" 
              :items-per-page="-1"
              density="compact"
              hover
              style="max-height: 400px; overflow-y: auto;"
            >
              <template v-slot:header.CRMWhatsappInvoiceID>
                <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
                  <v-icon size="small" color="indigo">mdi-barcode</v-icon>
                  <p><strong>ID</strong></p>
                </div>
              </template>
              <template v-slot:header.CRMWhatsappContactID>
                <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
                  <v-icon size="small" color="indigo">mdi-account</v-icon>
                  <p><strong>CONTACTO</strong></p>
                </div>
              </template>
              <template v-slot:header.CRMWhatsappInvoiceCreationDatetime>
                <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
                  <v-icon size="small" color="indigo">mdi-clock</v-icon>
                  <p><strong>CREACIÓN</strong></p>
                </div>
              </template>
              <template v-slot:header.CRMWhatsappInvoiceAmount>
                <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
                  <v-icon size="small" color="indigo">mdi-cash</v-icon>
                  <p><strong>MONTO</strong></p>
                </div>
              </template>
              <template v-slot:header.CRMWhatsappInvoiceCreationCRMAgentID>
                <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
                  <v-icon size="small" color="indigo">mdi-briefcase-account</v-icon>
                  <p><strong>AGENTE</strong></p>
                </div>
              </template>
              <template v-slot:header.CRMWhatsappInvoiceCRMLocalityID>
                <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
                  <v-icon size="small" color="indigo">mdi-store</v-icon>
                  <p><strong>LOCALIDAD</strong></p>
                </div>
              </template>
              <template v-slot:header.CRMWhatsappInvoiceProductsAction>
                <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
                  <v-icon size="small" color="indigo">mdi-package</v-icon>
                  <p><strong>PRODUCTOS</strong></p>
                </div>
              </template>
              <template v-slot:header.CRMWhatsappConversationAction>
                <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
                  <v-icon size="small" color="indigo">mdi-chat</v-icon>
                  <p><strong>CONVERSACIÓN</strong></p>
                </div>
              </template>
              <template v-slot:item.CRMWhatsappInvoiceID="{ item }">
                <v-hover v-slot="{ isHovering, props: hoverProps }">
                  <template v-if="isHovering == true && !systemInformationData.tooltipDisabled">
                    <v-tooltip v-bind="hoverProps" text="Copiar ID al portapapeles" location="top">
                      <template v-slot:activator="{ props: tooltipProps }">
                        <p v-bind="tooltipProps" @click="$generalFunctions.default.copyToClipboard(this, 'ID de la orden', 'o', item.CRMWhatsappInvoiceID)" class="hoverableText" style="color: #3F51B5;"><strong>{{ item.CRMWhatsappInvoiceID }}</strong></p>
                      </template>
                    </v-tooltip>
                  </template>
                  <template v-else>
                    <p v-bind="hoverProps" @click="$generalFunctions.default.copyToClipboard(this, 'ID de la orden', 'o', item.CRMWhatsappInvoiceID)" class="hoverableText" style="color: #3F51B5;"><strong>{{ item.CRMWhatsappInvoiceID }}</strong></p>
                  </template>
                </v-hover>
              </template>
              <template v-slot:item.CRMWhatsappContactID="{ item }">
                <div style="white-space: nowrap;">
                  <p>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(item) }}</p>
                  <p style="font-size: small; color: #9e9e9e;">{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(item.CRMWhatsappContactPhoneNumber, false) }}</p>
                </div>
              </template>
              <template v-slot:item.CRMWhatsappInvoiceCreationDatetime="{ item }">
                <p style="white-space: nowrap;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(item.CRMWhatsappInvoiceCreationDatetime) }}</p>
              </template>
              <template v-slot:item.CRMWhatsappInvoiceAmount="{ item }">
                <p><span style="color: #3F51B5; margin-right: 5px;"><strong>₡</strong></span>{{ $displayFunctions.default.parseAmountToDisplay(Math.round((item.CRMWhatsappInvoiceAmount || 0) / 5) * 5) }}</p>
              </template>
              <template v-slot:item.CRMWhatsappInvoiceCreationCRMAgentID="{ item }">
                <template v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.CRMWhatsappInvoiceCreationCRMAgentID)">
                  <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.CRMWhatsappInvoiceCreationCRMAgentID).CRMAgentColor || 'primary'" variant="flat" elevation="2" label>
                    <div style="display: flex; align-items: center;">
                      <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.CRMWhatsappInvoiceCreationCRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.CRMWhatsappInvoiceCreationCRMAgentID).CRMAgentName || 'No registrado' }}</p>
                    </div>
                  </v-chip>
                </template>
                <template v-else>
                  <v-chip color="primary" variant="flat" elevation="2" label>
                    <div style="display: flex; align-items: center;">
                      <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <p>No registrado</p>
                    </div>
                  </v-chip>
                </template>
              </template>
              <template v-slot:item.CRMWhatsappInvoiceCRMLocalityID="{ item }">
                <v-template v-if="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.CRMWhatsappInvoiceCRMLocalityID)">
                  <v-chip :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.CRMWhatsappInvoiceCRMLocalityID).CRMLocalityColor || 'primary'" variant="flat" elevation="2" label>
                    <p>{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.CRMWhatsappInvoiceCRMLocalityID).CRMLocalityName || 'No registrada' }}</p>
                    <div v-if="item.CRMWhatsappInvoiceCRMLocalityMapDivisionID" style="display: flex; align-items: center;">
                      <v-icon size="small" style="margin: 0px 5px;">mdi-arrow-right-bold</v-icon>
                      <p style="font-size: x-small;">{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.CRMWhatsappInvoiceCRMLocalityID)?.CRMLocalityMap?.CRMLocalityMapDivisions?.find(CRMLocalityMapDivision => CRMLocalityMapDivision.CRMLocalityMapDivisionID == item.CRMWhatsappInvoiceCRMLocalityMapDivisionID)?.CRMLocalityMapDivisionName || 'No registrada' }}</p>
                    </div>
                  </v-chip>
                </v-template>
                <template v-else>
                  <v-chip color="primary" variant="flat" elevation="2" label>
                    <p>No registrada</p>
                  </v-chip>
                </template>
              </template>
              <template v-slot:item.CRMWhatsappInvoiceProductsAction="{ item }">
                <v-btn @click="$root.dialogComponent.openCRMWhatsappInvoiceDialog([item.CRMWhatsappInvoiceID])" color="primary" class="hoverableText">
                  <v-icon size="small" style="margin-right: 10px;">mdi-package</v-icon>
                  <p style="font-size: small;">PRODUCTOS</p>
                </v-btn>
              </template>
              <template v-slot:item.CRMWhatsappConversationAction="{ item }">
                <v-btn @click="$root.dialogComponent.openCRMWhatsappConversationDialog(item.CRMWhatsappInvoiceCRMWhatsappConversationID, true, false, false, true, true, true, false, false, false, false, false, false)" color="primary" class="hoverableText">
                  <v-icon size="small" style="margin-right: 10px;">mdi-chat</v-icon>
                  <p style="font-size: small;">CONVERSACIÓN</p>
                </v-btn>
              </template>
              <template v-slot:no-data>
                <div style="text-align: center; padding: 15px; cursor: default; user-select: none;">
                  <v-icon size="large" color="indigo">mdi-information</v-icon>
                  <p style="margin-top: 5px; color: #9e9e9e;">No existen órdenes para este agente en el rango de fecha seleccionado</p>
                </div>
              </template>
              <template v-slot:bottom></template>
            </v-data-table>
          </div>
        </v-card>
      </template>
    </div>
  </v-card>
</template>

<style scoped>
  .inputContainer {
    display: grid;
    align-items: center;
    padding: 10px;
    gap: 15px;
    grid-template-columns: 1.7fr 1.7fr 1fr; 
  }

  .fourColumnContainer {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 15px;
  }

  .notEvenlyDistributedTwoColumnContainer {
    display: grid;
    grid-template-columns: 0.33fr 0.67fr;
    gap: 15px;
  }

  .threeColumnContainer {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
  }

  .headerCard {
    padding: 15px;
    display: grid;
    justify-content: center;
    align-items: center;
    gap: 10px;
    grid-template-columns: repeat(2, 1fr);
  }
  
  .titleContainer {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .actionsContainer {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }

  .dialogFooterContainer {
    display: grid;
    align-items: center;
    grid-template-columns: 1.5fr 0.5fr;
    gap: 10px;
    padding: 10px;
  }

  .summaryContainer {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .paginatorContainer {
    margin-left: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: 1200px) {
    .inputContainer {
      grid-template-columns: 1fr;
    }
    .fourColumnContainer {
      grid-template-columns: 1fr;
    }
    .notEvenlyDistributedTwoColumnContainer {
      grid-template-columns: 1fr;
    }
    .threeColumnContainer {
      grid-template-columns: 1fr;
    }
    .headerCard {
      grid-template-columns: repeat(1, 1fr);
    }
    .titleContainer {
      justify-content: center;
    }
    .actionsContainer {
      justify-content: center;
      margin-left: 0;
    }
    .dialogFooterContainer {
      grid-template-columns: 1fr;
    }
    .summaryContainer {
      align-items: center;
      justify-content: center;
    }
    .paginatorContainer {
      justify-content: center;
      margin-left: 0;
    }
  }
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import { VDateInput } from 'vuetify/labs/VDateInput';
  import VueApexCharts from 'vue3-apexcharts';
  export default {
    inject: ['$generalFunctions', '$displayFunctions', '$assets'],
    components: 
    {
      VDateInput,
      apexchart: VueApexCharts
    },
    data: () => ({
      input: 
      {
        CRMAgentID: 'null',
        date: [new Date()],
        CRMWhatsappConversationCountChartType: 'total',
        CRMWhatsappInvoicesPage: 1,
        CRMWhatsappConversationsPage: 1
      },
      display: 
      {
        CRMDashboardCRMAgentSummaryInformation: null,
        CRMAgentStatusChangeHeaders: 
        [
          {title: 'ID', key: 'CRMAgentStatusChangeID', sortable: false},
          {title: 'ESTADO', key: 'CRMAgentStatusChangeStatus', sortable: false},
          {title: 'FECHA', key: 'CRMAgentStatusChangeDatetime', sortable: false},
          {title: 'DURACIÓN', key: 'CRMAgentStatusChangeDuration', sortable: false}
        ],
        categoryColors: 
        {
          'ACCESORIOS': '#475569',
          'DESECHABLES': '#6D28D9',
          'DISPOSITIVOS': '#1E40AF',
          'E-LIQUIDS': '#6aa394',
          'HERB': '#065F46',
          'NARGILAS': '#312E81',
          'NIC SALTS': '#155E75',
          'POUCHES': '#3F3F46',
          'RESISTENCIAS': '#0F172A',
          'TABACO': '#3F6212'
        },
        CRMWhatsappInvoices: [],
        CRMWhatsappInvoicesSummary: {},
        offsetCRMWhatsappInvoicesSummary: {},
        CRMWhatsappConversations: [],
        CRMWhatsappConversationsSummary: {},
        offsetCRMWhatsappConversationsSummary: {}
      },
      navigation:
      {
        CRMWhatsappConversationsDialogIsVisible: false,
        newCRMWhatsappContact: false,
        isCRMWhatsappContactFollowup: false,
        CRMWhatsappConversationsLimit: 100
      },
      loader:
      {
        selectCRMDashboardCRMAgentSummaryInformation: false,
        selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformation: false,
        selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformationPagination: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgents: [],
        CRMLocalities: [],
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    computed: 
    {
      computed_CRMWhatsappConversationsHeaders() {
        const CRMWhatsappConversationsHeaders =
        [
          {title: 'ID', key: 'CRMWhatsappConversationID', sortable: false},
          {title: 'CONTACTO', key: 'CRMWhatsappContactID', sortable: false},
          {title: 'INICIO', key: 'CRMWhatsappConversationFirstCRMAgentID', sortable: false},
          {title: 'FIN', key: 'CRMWhatsappConversationCurrentCRMAgentID', sortable: false},
          {title: 'DURACIÓN', key: 'CRMWhatsappConversationDuration', sortable: false},
          {title: 'RESULTADO', key: 'CRMWhatsappConversationResult', sortable: false},
          {title: 'CONVERSACIÓN', key: 'CRMWhatsappConversationAction', sortable: false},
          {title: 'RETOMAR', key: 'CRMWhatsappConversationResumeAction', sortable: false}
        ];
        return CRMWhatsappConversationsHeaders;
      },

      computed_topCRMWhatsappInvoicesHeaders() {
        const CRMWhatsappInvoicesHeaders = 
        [
          {title: 'ID', key: 'CRMWhatsappInvoiceID', sortable: false},
          {title: 'CONTACTO', key: 'CRMWhatsappContactID', sortable: false},
          {title: 'CREACIÓN', key: 'CRMWhatsappInvoiceCreationDatetime', sortable: false},
          {title: 'MONTO', key: 'CRMWhatsappInvoiceAmount', sortable: false},
          ...(this.input.CRMAgentID == 'null' ? [{title: 'AGENTE', key: 'CRMWhatsappInvoiceCreationCRMAgentID', sortable: false}] : []),
          {title: 'LOCALIDAD', key: 'CRMWhatsappInvoiceCRMLocalityID', sortable: false},
          {title: 'PRODUCTOS', key: 'CRMWhatsappInvoiceProductsAction', sortable: false},
          {title: 'CONVERSACIÓN', key: 'CRMWhatsappConversationAction', sortable: false}
        ];
        return CRMWhatsappInvoicesHeaders;
      }
    },
    
    methods: 
    {
      async selectCRMDashboardCRMAgentSummaryInformation(){
        if (this.input.date.length == 0) this.input.date = [new Date()];
        this.input.CRMWhatsappConversationCountChartType = 'total';
        this.display.CRMDashboardCRMAgentSummaryInformation = null;
        this.loader.selectCRMDashboardCRMAgentSummaryInformation = true;
        const selectCRMDashboardCRMAgentSummaryInformationRequestQuery =
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.input.CRMAgentID == 'null' ? null : this.input.CRMAgentID
          },
          'startDate': this.input.date[0],
          'endDate': this.input.date[this.input.date.length - 1]
        };
        const selectCRMDashboardCRMAgentSummaryInformationResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAccount/functions/selectCRMDashboardCRMAgentSummaryInformation', selectCRMDashboardCRMAgentSummaryInformationRequestQuery);
        if (selectCRMDashboardCRMAgentSummaryInformationResult.success) {
          this.display.CRMDashboardCRMAgentSummaryInformation = selectCRMDashboardCRMAgentSummaryInformationResult.result;
          this.processCRMDashboardCRMAgentSummaryInformation();
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMDashboardCRMAgentSummaryInformation_error', 'error', 'Ha ocurrido un error inesperado al consultar el resumen por agente, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
        this.loader.selectCRMDashboardCRMAgentSummaryInformation = false;
      },

      async selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformation(isNewSearch) {
        if (isNewSearch) {
          this.input.CRMWhatsappConversationsPage = 1;
          this.display.CRMWhatsappConversationsSummary = {};
          this.display.CRMWhatsappConversations.length = 0;
          this.loader.selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformation = true;
        }
        this.navigation.CRMWhatsappConversationsDialogIsVisible = true;
        this.loader.selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformationPagination = true;
        const selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformationRequestQuery =
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.input.CRMAgentID == 'null' ? null : this.input.CRMAgentID
          },
          'newCRMWhatsappContact': this.navigation.newCRMWhatsappContact,
          'isCRMWhatsappContactFollowup': this.navigation.isCRMWhatsappContactFollowup,
          'startDate': this.input.date[0],
          'endDate': this.input.date[this.input.date.length - 1],
          'page': this.input.CRMWhatsappConversationsPage,
          'limit': this.navigation.CRMWhatsappConversationsLimit
        };
        const selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformationResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/functions/selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformation', selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformationRequestQuery);
        if (selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformationResult.success) {
          this.display.CRMWhatsappConversations = selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformationResult.result.CRMWhatsappConversations;
          this.display.CRMWhatsappConversationsSummary = selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformationResult.result.CRMWhatsappConversationsSummary;
          this.display.offsetCRMWhatsappConversationsSummary = selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformationResult.result.offsetCRMWhatsappConversationsSummary;
          this.loader.selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformation = false;
          this.loader.selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformationPagination = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformation_error', 'error', 'Ha ocurrido un error inesperado al consultar las conversaciones, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          this.navigation.CRMWhatsappConversationsDialogIsVisible = false;
        }
      },

      async processCRMDashboardCRMAgentSummaryInformation() {
        const CRMAgentStatusChanges = this.display.CRMDashboardCRMAgentSummaryInformation.CRMAgentStatusChanges.slice().filter(CRMAgentStatusChange => CRMAgentStatusChange.isOffset == false);
        let CRMAgentOnlineTime = 0;
        let lastCRMAgentStatusChangeDatetime = null;
        for (const CRMAgentStatusChange of CRMAgentStatusChanges) {
          const CRMAgentStatusChangeDatetime = new Date(CRMAgentStatusChange.CRMAgentStatusChangeDatetime);
          if (CRMAgentStatusChange.CRMAgentStatusChangeStatus == 'active') {
            lastCRMAgentStatusChangeDatetime = CRMAgentStatusChangeDatetime;
          } else if (lastCRMAgentStatusChangeDatetime) {
            CRMAgentOnlineTime += CRMAgentStatusChangeDatetime - lastCRMAgentStatusChangeDatetime;
            lastCRMAgentStatusChangeDatetime = null;
          }
        }
        if (lastCRMAgentStatusChangeDatetime) CRMAgentOnlineTime += new Date() - lastCRMAgentStatusChangeDatetime;
        this.display.CRMDashboardCRMAgentSummaryInformation.CRMAgentOnlineTime = CRMAgentOnlineTime;
        let offsetCRMAgentStatusChanges = this.display.CRMDashboardCRMAgentSummaryInformation.CRMAgentStatusChanges.slice().filter(CRMAgentStatusChange => CRMAgentStatusChange.isOffset == true);
        let offsetCRMAgentOnlineTime = 0;
        lastCRMAgentStatusChangeDatetime = null;
        for (const CRMAgentStatusChange of offsetCRMAgentStatusChanges) {
          const CRMAgentStatusChangeDatetime = new Date(CRMAgentStatusChange.CRMAgentStatusChangeDatetime);
          if (CRMAgentStatusChange.CRMAgentStatusChangeStatus == 'active') {
            lastCRMAgentStatusChangeDatetime = CRMAgentStatusChangeDatetime;
          } else if (lastCRMAgentStatusChangeDatetime) {
            offsetCRMAgentOnlineTime += CRMAgentStatusChangeDatetime - lastCRMAgentStatusChangeDatetime;
            lastCRMAgentStatusChangeDatetime = null;
          }
        }
        if (lastCRMAgentStatusChangeDatetime) offsetCRMAgentOnlineTime += new Date() - lastCRMAgentStatusChangeDatetime;
        this.display.CRMDashboardCRMAgentSummaryInformation.offsetCRMAgentOnlineTime = offsetCRMAgentOnlineTime;
        this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCountChartOptions = 
        {
          chart: {type: 'donut', height: '100%', width: '100%', toolbar: {show: false}},
          colors: ['#008a2b', '#a60319'],
          legend: {show: false},
          tooltip: {
            enabled: true,
            custom: function({ seriesIndex }) {
              const current = seriesIndex == 0 ? this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceCount : this.display.CRMDashboardCRMAgentSummaryInformation.notSelledCRMWhatsappConversationCount;
              return `
                <div style="padding: 5px; border-radius: 5px; border: 2px solid ${seriesIndex == 0 ? '#008a2b' : '#a60319'}; background: white; color: black;">
                  <p><strong>${seriesIndex == 0 ? 'Conversaciones vendidas' : 'Conversaciones no vendidas'}:</strong> ${this.$displayFunctions.default.parseAmountToDisplayWithoutDecimals(current)}</p>
                  <p style="font-size: x-small; color: #9e9e9e;">Click para ver detalle...</p>
                </div>
              `;
            }.bind(this)
          }
        };
        this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCountChartOptionsNC = 
        {
          chart: {type: 'donut', height: '100%', width: '100%', toolbar: {show: false}},
          colors: ['#008a2b', '#a60319'],
          legend: {show: false},
          tooltip: {
            enabled: true,
            custom: function({ seriesIndex }) {
              const current = seriesIndex == 0 ? this.display.CRMDashboardCRMAgentSummaryInformation.newCRMWhatsappInvoiceCount.newCRMWhatsappInvoiceCount : this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.CRMWhatsappConversationCount.newCRMWhatsappConversationCount - this.display.CRMDashboardCRMAgentSummaryInformation.newCRMWhatsappInvoiceCount.newCRMWhatsappInvoiceCount;
              return `
                <div style="padding: 5px; border-radius: 5px; border: 2px solid ${seriesIndex == 0 ? '#008a2b' : '#a60319'}; background: white; color: black;">
                  <p><strong>${seriesIndex == 0 ? 'Órdenes de nuevos contactos' : 'Conversaciones no vendidas de nuevos contactos'}:</strong> ${this.$displayFunctions.default.parseAmountToDisplayWithoutDecimals(current)}</p>
                  <p style="font-size: x-small; color: #9e9e9e;">Click para ver detalle...</p>
                </div>
              `;
            }.bind(this)
          }
        };
        this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCountChartSeries = 
        [
          this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoices.CRMWhatsappInvoices.CRMWhatsappInvoiceCount, 
          this.display.CRMDashboardCRMAgentSummaryInformation.notSelledCRMWhatsappConversationCount
        ];
        this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCountChartSeriesNC = 
        [
          this.display.CRMDashboardCRMAgentSummaryInformation.newCRMWhatsappInvoiceCount.newCRMWhatsappInvoiceCount, 
          this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappConversationCount.CRMWhatsappConversationCount.newCRMWhatsappConversationCount - this.display.CRMDashboardCRMAgentSummaryInformation.newCRMWhatsappInvoiceCount.newCRMWhatsappInvoiceCount
        ];
        this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceProductAmountChartOptions = 
        {
          chart: {type: 'donut', height: '100%', width: '100%', toolbar: {show: false}},
          colors: this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceProductAmount.map(productCategory => this.display.categoryColors[productCategory.productCategoryName]),
          legend: {show: false},
          labels: this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceProductAmount.map(productCategory => productCategory.productCategoryName),
          tooltip: {
            enabled: true,
            custom: function({ seriesIndex }) {
              const color = seriesIndex == 0 ? this.display.categoryColors[this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceProductAmount[seriesIndex].productCategoryName] : this.display.categoryColors[this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceProductAmount[seriesIndex].productCategoryName];
              const name = seriesIndex == 0 ? this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceProductAmount[seriesIndex].productCategoryName : this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceProductAmount[seriesIndex].productCategoryName;
              const amount = seriesIndex == 0 ? this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceProductAmount[seriesIndex].CRMWhatsappInvoiceProductAmount : this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceProductAmount[seriesIndex].CRMWhatsappInvoiceProductAmount;
              return `
                <div style="padding: 5px; border-radius: 5px; border: 2px solid ${color}; background: white; color: black;">
                  <p><strong>${name}:</strong> ${this.$displayFunctions.default.parseAmountToDisplayWithoutDecimals(amount)}</p>
                  <p style="font-size: x-small; color: #9e9e9e;">Click para ver detalle...</p>
                </div>
              `;
            }.bind(this)
          }
        };
        this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceProductAmountChartSeries = this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceProductAmount.map(productCategory => productCategory.CRMWhatsappInvoiceProductAmount);
        
        
        this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappContactFollowupCountChartOptions =
        {
          chart: {type: 'donut', height: '100%', width: '100%', toolbar: {show: false}},
          colors: ['#008a2b', '#a60319'],
          legend: {show: false},
          tooltip: {
            enabled: true,
            custom: function({ seriesIndex }) {
              const current = seriesIndex == 0 ? this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappContactFollowupCount.CRMWhatsappContactFollowupCount.selledCRMWhatsappContactFollowupCount : this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappContactFollowupCount.CRMWhatsappContactFollowupCount.notSelledCRMWhatsappContactFollowupCount;
              return `
                <div style="padding: 5px; border-radius: 5px; border: 2px solid ${seriesIndex == 0 ? '#008a2b' : '#a60319'}; background: white; color: black;">
                  <p><strong>${seriesIndex == 0 ? 'Seguimientos vendidos' : 'Seguimientos no vendidos'}:</strong> ${this.$displayFunctions.default.parseAmountToDisplayWithoutDecimals(current)}</p>
                  <p style="font-size: x-small; color: #9e9e9e;">Click para ver detalle...</p>
                </div>
              `;
            }.bind(this)
          }
        };
        this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappContactFollowupCountChartSeries = 
        [
          this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappContactFollowupCount.CRMWhatsappContactFollowupCount.selledCRMWhatsappContactFollowupCount,
          this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappContactFollowupCount.CRMWhatsappContactFollowupCount.notSelledCRMWhatsappContactFollowupCount
        ];

        
        
        this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceCountChartOptions = {
          chart: {type: 'area', height: '300px', width: '100%', toolbar: {show: false}, zoom: {enabled: false}},
          xaxis: {categories: this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceCountByHour.map(item => item.CRMWhatsappInvoiceCreationHour > 12 ? `${item.CRMWhatsappInvoiceCreationHour - 12}:00 PM` : `${item.CRMWhatsappInvoiceCreationHour}:00 AM`), tooltip: {enabled: false}},
          stroke: {curve: 'smooth'},
          colors: ['#3F51B5'],
          dataLabels: {enabled: true, style: {fontSize: '20px'}, formatter: value => this.$displayFunctions.default.parseAmountToDisplayWithoutDecimals(value)},
          tooltip: {
            enabled: true,
            custom: function({ dataPointIndex }) {
              const hour = this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceCountByHour[dataPointIndex].CRMWhatsappInvoiceCreationHour > 12 ? `${this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceCountByHour[dataPointIndex].CRMWhatsappInvoiceCreationHour - 12}:00 PM` : `${this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceCountByHour[dataPointIndex].CRMWhatsappInvoiceCreationHour}:00 AM`;
              const amount = this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceCountByHour[dataPointIndex].CRMWhatsappInvoiceCount;
              return `
                <div style="padding: 5px; border-radius: 5px; border: 2px solid #3F51B5; background: white; color: black;">
                  <p><strong>${hour}</strong>: ${this.$displayFunctions.default.parseAmountToDisplayWithoutDecimals(amount)}</p>
                  <p style="font-size: x-small; color: #9e9e9e;">Click para ver detalle...</p>
                </div>
              `;
            }.bind(this)
          }
        };
        this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceCountChartSeries = [{name: "Órdenes", data: this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceCountByHour.map(item => item.CRMWhatsappInvoiceCount)}];
      },

      clickOnCRMWhatsappContactFollowupCountChart(_, __, config) {
        const isCRMWhatsappContactFollowup = config.dataPointIndex == 0 ? true : false;
        if (isCRMWhatsappContactFollowup) this.$root.dialogComponent.openCRMWhatsappInvoicesDialog(this.input.date, this.input.CRMAgentID, false, null, null, [], null, null, isCRMWhatsappContactFollowup);
        else {
          this.navigation.newCRMWhatsappContact = false;
          this.navigation.isCRMWhatsappContactFollowup = true;
          this.selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformation(true);
        }
      },

      clickOnCRMWhatsappInvoiceProductAmountChart(_, __, config) {
        const productCategoryID = this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceProductAmount[config.dataPointIndex] ? this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceProductAmount[config.dataPointIndex].productCategoryID : null;
        this.$root.dialogComponent.openCRMWhatsappInvoicesDialog(this.input.date, this.input.CRMAgentID, false, productCategoryID, null, [], null, null, null);
      },

      clickOnCRMWhatsappInvoiceCountChart(_, __, opts) {
        const CRMWhatsappInvoiceCreationHour = this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceCountByHour[opts.dataPointIndex] ? this.display.CRMDashboardCRMAgentSummaryInformation.CRMWhatsappInvoiceCountByHour[opts.dataPointIndex].CRMWhatsappInvoiceCreationHour : null;
        this.$root.dialogComponent.openCRMWhatsappInvoicesDialog(this.input.date, this.input.CRMAgentID, false, null, CRMWhatsappInvoiceCreationHour, [], null, null, null);
      },

      clickOnCRMWhatsappConversationCountChart(_, __, opts) {
        if (this.input.CRMWhatsappConversationCountChartType == 'total') { 
          if (opts.dataPointIndex == 0) this.$root.dialogComponent.openCRMWhatsappInvoicesDialog(this.input.date, this.input.CRMAgentID, false, null, null, [], null, null, null);
          else {
            this.navigation.newCRMWhatsappContact = false;
            this.navigation.isCRMWhatsappContactFollowup = false;
            this.selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformation(true);
          }
        } else {
          if (opts.dataPointIndex == 0) this.$root.dialogComponent.openCRMWhatsappInvoicesDialog(this.input.date, this.input.CRMAgentID, true, null, null, [], null, null, null);
          else {
            this.navigation.newCRMWhatsappContact = true;
            this.navigation.isCRMWhatsappContactFollowup = false;
            this.selectCRMWhatsappConversationFromCRMDashboardCRMAgentSummaryInformation(true);
          }
        }
      },

      async getSystemInformationData(){
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgents = [{CRMAgentID: 'null', CRMAgentName: 'GLOBAL'}, ...systemInformation.getCRMAgents];
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      }
    },  

    async mounted() {
      await this.getSystemInformationData();
      this.selectCRMDashboardCRMAgentSummaryInformation();
    }
  }
</script>